import styled from '@emotion/styled'
import { Box, Button, ClickAwayListener, Grid } from '@mui/material'
import React from 'react'
import { COLOR_MAP } from '../../../../constants/ColorNames'
import { CampaignPlaceHolderDetails } from '../../../../types/dataTypes'
import Label from '../../../../common/components/Label'
import TextBox from '../../../../common/components/Textbox'

type CampaignPlaceHolderInputPropsType = {
  placeHolderDetails: CampaignPlaceHolderDetails,
  handleCampiagnInputDetailsUpdate: (jobTitle: string, value: string) => void,
  handleModalClose: () => void
}

const PlaceholderWrapper = styled(Box)`
  border: 1px solid ${COLOR_MAP.BORDER_GREY};
  box-shadow: 0px 12px 16px -6px #00000026, 0px 4px 4px -2px #0000001A;
  position: absolute;
  background-color: ${COLOR_MAP.WHITE};
  min-width: 392px;
  border-radius: 8px;
  padding: 16px;
`;

const PlaceholderBox = styled(Grid)`
  gap: 8px;
`

const PlaceholderContentWrapper = styled(Grid)`
`

const PlaceholderActions = styled(Grid)`
  text-align: end;
`

export const CampaignPlaceholderInput = (props: CampaignPlaceHolderInputPropsType) => {
  const { placeHolderDetails: { top, left, content, value }, handleCampiagnInputDetailsUpdate, handleModalClose } = props;
  const [inputValue, setInputValue] = React.useState<string>(value);
  const label = content ? content.split('@')[1] : '';
  const windowWidth = window.innerWidth;


  const handelEnterKey = React.useCallback((e:any) => {
    if(e.keyCode === 13 && inputValue){
     handleCampiagnInputDetailsUpdate(content, inputValue)
    }
  }, [content, handleCampiagnInputDetailsUpdate, inputValue])



  let xPoint = top;
  let yPoint = left

  if (left + 410 > windowWidth) {
    xPoint = top - 114;
    yPoint = left - 400;
  }

  return (
    <ClickAwayListener onClickAway={handleModalClose}>
    <PlaceholderWrapper
      sx={{
        top: xPoint,
        left: yPoint,
      }}
    >
      <PlaceholderBox container direction={'column'}>
        <PlaceholderContentWrapper item>
          <Label
            label={label}
            labelFor="campaignName"
            required
            colorType="light"
          />
          <TextBox
            placeholder={`Enter text`}
            sx={{
              marginTop: '4px',
              color: COLOR_MAP.GREY_0
            }}
            textValue={inputValue}
            handleChange={(e) => setInputValue(e.target.value)}
            id='compaignAttributte'
            onKeyDown={handelEnterKey}
      
          />
        </PlaceholderContentWrapper>
        <PlaceholderActions item>
          <Button type='submit' sx={{ padding: '8px 12px' }} disabled={!inputValue} variant="contained" disableRipple onClick={() => handleCampiagnInputDetailsUpdate(content, inputValue)}>Save</Button>
        </PlaceholderActions>
      </PlaceholderBox>
    </PlaceholderWrapper>
    </ClickAwayListener>
  )
}
